<template>
  <div class="modal fade" id="AddPaiementModal" tabindex="-1" role="dialog" ref="addPaiementModalRef"
    aria-labelledby="tooltipmodal" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="paiement">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">{{ title }}</h4>
          <button ref="closePaiementModal" class="btn-close py-0" type="button" data-bs-dismiss="modal"
            aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <Form ref="paiementForm" @submit="payer" :validation-schema="paiementSchema">
            <div class="row">
              <div class="col-md-12 col-sm-12 col-xm-12 col-xl-12 col-lg-12" v-if="showType">
                <div class="upload-container">
                  <input type="file" name="urlImage" ref="fileInput" @change="(event) => onFilePrinChange(event)"
                    accept="image/*" hidden />
                  <div class="preview-card" @click="triggerFileInput">
                    <img v-if="imagePreview" :src="imagePreview" alt="Image preview" />
                    <div v-else class="text-center">
                      <div>
                        <i class="flaticon-camera fs-1"></i>
                      </div>
                      Cliquez pour ajouter l'image
                    </div>
                    <button v-if="imagePreview" class="delete-btn" @click.stop="removeImage">
                      <i class="flaticon-close"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12 col-xm-12 col-sm-12 col-xl-12 col-lg-12" v-if="showType">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Réference <span class="text-danger">*</span>
                  </label>
                  <Field name="referenceDocument" type="text" class="form-control shadow-none fs-md-15 text-black"
                    placeholder="Entrer la référence du paiement du trésor" />
                  <ErrorMessage name="referenceDocument" class="text-danger" />
                </div>
              </div>
              <div class="col-md-6 col-xm-12 col-sm-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Date paiement <span class="text-danger">*</span>
                  </label>
                  <Field name="date_paiement" v-model="date" type="date"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer date" />
                  <ErrorMessage name="date_paiement" class="text-danger" />
                </div>
              </div>

              <div class="col-md-6 col-xm-12 col-sm-12 col-xl-6 col-lg-6">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold">
                    Montant <span class="text-danger">*</span>
                  </label>
                  <Field name="montant" type="number" v-model="montant"
                    class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer montant" disabled />
                  <ErrorMessage name="montant" class="text-danger" />
                </div>
              </div>
              <div class="col-md-3 col-xm-12 col-sm-12 col-xl-3 col-lg-3 mb-10">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold mb-10">
                    Mode <span class="text-danger">*</span>
                  </label>
                  <Field name="mode" v-slot="{ field }" v-model="mode">
                    <Multiselect factureholder="Rechercher un mode" :filter-results="true" v-model="field.value"
                      v-bind="field" :searchable="true" :options="modeOptions" />
                  </Field>
                  <ErrorMessage name="mode" class="text-danger" />
                </div>
              </div>

              <div class="col-md-9 col-xm-12 col-sm-12 col-xl-9 col-lg-9 mb-10">
                <div class="form-group">
                  <label class="d-block text-black fw-semibold mb-10">
                    Facture <span class="text-danger">*</span>
                  </label>
                  <Field name="facture" v-slot="{ field }">
                    <Multiselect v-bind="field" factureholder="Rechercher une facture" :filter-results="false"
                      :min-chars="3" :resolve-on-load="false" :delay="0" :searchable="true" :options-limit="300"
                      :options="async (query) => await fetchFactures(query)" noResultText="Aucun enregistrement trouvé"
                      noOptionsText="Tapez au moins trois caractères" @select="selectionFacture" />
                  </Field>
                  <ErrorMessage name="facture" class="text-danger" />
                </div>
              </div>
              <button class="btn btn-success" v-show="!auclic" type="submit">
                {{ btntext }}

              </button>
              <button class="btn btn-success" type="button" v-show="auclic" disabled>
                <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
                <span class="visually-hidden">Loading...</span>
              </button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { ref, watch, onMounted, toRef, reactive } from 'vue';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as Yup from 'yup';
import ApiService from '@/services/ApiService';
import axios from "axios";
import { dateActuelle, error, hideModal, success } from '@/utils/utils';
import router from '@/router';
import { Paiement } from '@/models/Paiement';
import Multiselect from '@vueform/multiselect';
import { KKIAPAY } from '@/models/KKIAPAY';
import { addKkiapayListener } from 'kkiapay';
import Swal from 'sweetalert2';
import { reference } from '@popperjs/core';


export default {
  name: "AddPaiementModal",
  components: {
    Form,
    Field,
    ErrorMessage,
    Multiselect
  },
  props: {
    id: {
      type: Number,
      required: true,
      default: 0
    },
  },
  emits: ["getAllPaiements", "openmodal"],

  setup: (props, { emit }) => {
    const loading = ref<boolean>(false);
    const paiementSchema = Yup.object().shape({
      date_paiement: Yup.string().required('La date de paiement est obligatoire'),
      montant: Yup.string().required('Le montant est obligatoire'),
      facture: Yup.string().required('La facture est obligatoire'),
      mode: Yup.string().required('Le mode est obligatoire'),
      referenceDocument: Yup.string().when('mode', {
        is: "TRESOR PUBLIC",
        then: schema => schema.required("Le mode est obligatoire"),
        otherwise: schema => schema.required("Le mode est obligatoire")
      })
    });
    const images = reactive([
      {
        file: null as File | null,
        previewUrl: null as string | null,
      },
    ]);
    const auclic = ref(false)
    const closePaiementModal = ref(null);
    const paiementForm = ref<Paiement | null>(null);
    const addPaiementModalRef = ref<null | HTMLElement>(null);
    const title = ref('Ajouter un paiement');
    const btntext = ref('Ajouter');
    const isupdate = ref(false);
    const facture = ref();
    const date = ref(new Date().toISOString().slice(0, 10));
    const factureOptions = ref();
    const montant = ref();
    const showType = ref(true);
    const modeOptions = ref([
      { value: 'TRESOR PUBLIC', label: 'TRESOR PUBLIC' },
      { value: 'KKIPAY', label: 'KKIPAY' },
      { value: 'ESPECE', label: 'ESPECE' },
    ]);

    const noOptionsTextAbb = ref("Tapez au moins trois caractères");
    const nooptions = "Aucun enregistrement trouvé";
    const noResultText = "Aucun enregistrement trouvé";

    const selectionFacture = async (valeur) => {
      try {
        const fact = (await axios.get(`factures/${valeur}`)).data.data;
        console.log("Retour ===> ", fact?.montant_facture)
        montant.value = fact?.montant_facture;
      } catch (err) {
        console.log("Erreur", err)
        //error(err.response.message)
      }
      console.log("console.log() ===> ", valeur)
    }
    const fileInput = ref();


    const triggerFileInput = () => {
      fileInput.value.click();
    };

    const fetchFactures = async (key) => {
      try {
        const response = await axios.get(`/factures/recherche/${key}`);
        const facturesData = response.data.data;
        console.log(response.data.data)
        factureOptions.value = facturesData.map((factu) => (
          {
            value: `${factu.id}`,
            label: factu.caution ? factu.reference + "CAUTION DE LOYER de " + factu.nomMarchand + " [" + factu.codePlace + "]" : `${factu.reference} - ${factu?.codePlace}-[${factu.nomMarchand}] - ${factu.periode_facture}`,
          }));
        if (factureOptions.value.length == 0) {
          noOptionsTextAbb.value = noResultText;
        } else {
          noOptionsTextAbb.value = 'Tapez au moins trois caractères';
        }
        return factureOptions.value;
      } catch (error) {
        //
      }
    }
    watch(() => props.id, (newValue) => {
      if (newValue != 0) {
        getPaiement(newValue);
        isupdate.value = true;
        btnTitle();
      }

    });
    var check = reactive({
      typeError: "RAS",
      idTransaction: 0,
    });
    const btnTitle = async () => {
      if (isupdate.value) {
        title.value = "Modifier le paiement";
        btntext.value = "Modifier";
      } else {
        title.value = "Ajouter  le paiement";
        btntext.value = "Ajouter";
      }
    }
    const getPaiement = async (id: number) => {
      return ApiService.get("/paiments/" + id)
        .then(({ data }) => {
          paiementForm.value?.setFieldValue("id", data.data.id);
          paiementForm.value?.setFieldValue("reference", data.data.reference);
          paiementForm.value?.setFieldValue("date_paiement", data.data.date_paiement);
          paiementForm.value?.setFieldValue("montant", data.data.montant);
          paiementForm.value?.setFieldValue("facture", data.data.id);
          emit('openmodal', addPaiementModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
    }

    async function successHandler(response, values, { resetForm }) {
      check.typeError = "SUCCESS";
      check.idTransaction = response.transactionId;
      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      console.log("Checker ==> ", values);
      if (check.typeError === "SUCCESS") {
        await addPaiement(values, { resetForm });
      } else {
        check.typeError = "RAS";
        check.idTransaction = 0;
      }
      // Retourne les données après l'exécution
      return { check, response };
    }

    const imageFile = ref<File | null>(null);
    const imagePreview = ref<string | null>(null);



    const onFilePrinChange = (event: Event) => {
      const target = event.target as HTMLInputElement;
      const file = target.files?.[0];
      if (file) {
        imageFile.value = file;
        const reader = new FileReader();
        reader.onload = (e) => {
          imagePreview.value = e.target?.result as string;
        };
        reader.readAsDataURL(file);
      }
    };
    const onFileChange = (event, index) => {
      const file = event.target.files[0];
      if (file) {
        images[index].previewUrl = URL.createObjectURL(file);
        images[index].file = file;
      }
    };
    const removeImage = () => {
      imagePreview.value = null;
      imageFile.value = null;
    };

    async function failHandler(response, values, { resetForm }) {
      check.typeError = "ECHOUE";
      check.idTransaction = response.transactionId;
      check.typeError = "RAS";
      check.idTransaction = response.transactionId;

      values["idTransaction"] = check.idTransaction;
      values["check"] = check;
      // Bloc de code à exécuter lorsque le paiement est un succès
      if (check.typeError === "RAS") {
        // Appel de la fonction addAbonnement et attente de son exécution
        // await finishStep(values, { resetForm });
      }
      // Retourne les données après l'exécution
      return { check, response };
    }
    const mode = ref('TRESOR PUBLIC');

    watch(mode, async (newValue) => {
      console.log("Mode ===> ", newValue)
      if ((newValue).toString() == 'TRESOR PUBLIC') {
        showType.value = true;
      } else {
        showType.value = false;
      }
    });


    const addPaiement = async (values, { resetForm }) => {
      auclic.value = true;
      loading.value = false;
      if (isupdate.value) {
        ApiService.put(`/paiements/${values?.id}`, values)
          .then(({ data }) => {
            auclic.value = false;
            if (data.code == 200) {
              success(data.message);
              resetForm();
              hideModal(addPaiementModalRef.value);
              if (closePaiementModal.value) {
                (closePaiementModal.value as HTMLButtonElement).click()
              }
              isupdate.value = false;
              btnTitle();
              emit("getAllPaiements");
              router.push('/liste-paiement');
            }
          }).catch(({ response }) => {
            error(response.data.message)
          });
      } else {
        ApiService.post("/paiements", values)
          .then(({ data }) => {
            if (data.code == 201) {
              success(data.message);
              auclic.value = false;
              resetForm();
              hideModal(addPaiementModalRef.value);
              emit("getAllPaiements");
              router.push('/liste-paiement');
            }
          }).catch(({ response }) => {
            auclic.value = false;
            error(response.data.message)
          });
      }
    };
    const resetValue = () => {
      const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
      isupdate.value = false;
      formFields.forEach(field => {
        field.value = '';
      });
      btnTitle()
    };


    const payer = async (values, { resetForm }) => {
      console.log("Value de paiement = = > ", values);
      if (values.mode == "TRESOR PUBLIC" || values.mode == "ESPECE") {
        if (values.mode == "TRESOR PUBLIC") {
          if (imageFile.value) {
            values["urlImage"] = imageFile.value;
          }
          values["referenceDocument"] = values.reference;
        }
        try {
          const result = await Swal.fire({
            text:
              "Vous êtes sur le point de faire un paiement d'une somme de " +
              values.montant +
              " F CFA",
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-suucess",
              cancelButton: "btn btn-danger",
            },
          });

          if (result.isConfirmed) {
            values["check"] = KKIAPAY.check;
            await addPaiement(values, { resetForm });
          }
        } catch (error) {
          //
          auclic.value = true;
        }
      }
      if (values.mode == "KKIPAY") {
        try {
          const result = await Swal.fire({
            html:
              `Vous êtes sur le point de faire un paiement d'une somme de <b style="color:#dc3545;"> ${values.montant} </b>F CFA`,
            icon: "warning",
            buttonsStyling: true,
            showCancelButton: true,
            confirmButtonText: "Payer",
            cancelButtonText: `Annuler`,
            allowOutsideClick: false,
            allowEscapeKey: false,
            heightAuto: false,
            customClass: {
              confirmButton: "btn btn-success",
              cancelButton: "btn btn-danger",
            },
          });
          //await finishStep(values, { resetForm });
          if (result.isConfirmed) {
            KKIAPAY.kkia(values.montant);
            // Écoute des événements
            addKkiapayListener("failed", (event) => {
              failHandler(event, values, { resetForm });
              // Actions à prendre après l'échec
              console.log("Opération échouée.");
            });

            addKkiapayListener("success", (event) => {
              successHandler(event, values, { resetForm });
              // Actions à prendre après le succès
              console.log("Opération réussie.");
            });

            const checkRef = toRef(check);
            let resolved = false;

            // Vérification en continu de l'état
            const intervalId = setInterval(() => {
              if (!resolved && checkRef.value.typeError !== "RAS") {
                clearInterval(intervalId);
                resolved = true;
                // Actions à prendre après détection d'une erreur
              }
            }, 500);
          }
        } catch (error) {
          //
          auclic.value = true;
        }
      }
    };

    onMounted(() => {
      //getAllFactures();
    });
    return {
      mode,
      modeOptions,
      onFileChange,
      images,
      fileInput,
      showType,
      imagePreview,
      imageFile,
      removeImage,
      onFilePrinChange,
      triggerFileInput,
      check,
      auclic,
      payer,
      paiementSchema, facture, factureOptions, montant, selectionFacture, date,
      addPaiement, paiementForm, addPaiementModalRef, btntext, title, resetValue, fetchFactures, nooptions, noOptionsTextAbb, closePaiementModal
    };
  },
};

</script>

<style scoped>
/* Alignement des boutons radio à droite */
.radio-group-right {
  text-align: right;
  padding-right: 15px;
}

/* Ajustement responsive */
@media (max-width: 768px) {
  .radio-group-right {
    text-align: left;
    padding-right: 0;
  }
}

/* Transition fluide pour la colonne */
.col-md-3,
.col-md-9,
.col-md-12 {
  transition: all 0.3s ease;
}

.form-check {
  margin-right: 20px;
}

.form-check-input {
  margin-right: 5px;
}

.dropzone-container {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.default-image-container {
  text-align: center !important;
  margin: 20px 0 !important;
}

.default-image {
  width: 100px !important;
  height: auto !important;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.cursor-not-allowed {
  cursor: not-allowed;
}

.marge-droite {
  margin-left: 15px;
}

.hr-longeur {
  width: 80%;
}

.bord1 {
  border: 1px solid #07a;
}

.fond {
  background-color: rgb(94, 191, 233);
}

@import 'dropzone-vue/dist/dropzone-vue.common.css';

.upload-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 10px;
}

.preview-card {
  width: 100%;
  height: 240px;
  border: 2px dashed #4caf50;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  overflow: hidden;
  background: #f8f8f8;
  position: relative;
}

.preview-card img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.delete-btn {
  position: absolute;
  top: 5px;
  right: 5px;
  background: red;
  color: white;
  border: none;
  padding: 5px 8px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 16px;
}

.delete-btn:hover {
  background: darkred;
}
</style>